import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SMARTPHONE: GlameraIconDefinition = {
  name: 'smartphone',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-smartphone-body">
      <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
      <path class="glm-smartphone-dot" d="M12 18h.01"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-smartphone-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './smartphone.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SmartphoneIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SMARTPHONE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
